<nb-alert *ngFor="let alert of alerts" outline="{{alert.alertLevel}}">
  <div class="d-flex align-items-center">
    <div class="mr-3">
      <nb-icon icon="info-circle" style="font-size:2rem;"></nb-icon>
    </div>
    <div [innerHTML]="alert.content"></div>
  </div>
</nb-alert>
